import { render } from "./FriendSkeleton.vue?vue&type=template&id=39a10d70&scoped=true"
const script = {}

import "./FriendSkeleton.vue?vue&type=style&index=0&id=39a10d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a10d70"]])

export default __exports__